import type { DailyTag } from "@/pages/human-resources/time-management/business/daily-tag/DailyTag";
import {
  buildCommonParts,
  mapToWorkType,
  type PrintCommonParts,
} from "@/pages/human-resources/time-management/endpoints/schedules/print/inout/CommonParts";
import type { DisplayOptions } from "@/pages/human-resources/time-management/model/display-options/DisplayOptions";
import { legacyFormatFrenchDate } from "@/shared/utils/LegacyDates";
import type { ScheduleViewFilters } from "@/pages/human-resources/time-management/components/display-filters/provider/ScheduleViewFilters.ts";
import {
  mapFromArrangementAndOrder,
  type PrintArrangementIn,
} from "@/pages/human-resources/time-management/endpoints/schedules/print/inout/PrintArrangementIn.ts";

export interface PrintMonthlyScheduleIn extends PrintCommonParts {
  date: string; // uses format: dd/MM/yyyy
  idsSites: string[];
  mode: "recapempparpage" | "recapparsite";
  tempsTravail: "effectif" | "valorise";
  condensed: boolean;
  arrangement: PrintArrangementIn;
}

export function inputForPrintMonthlySchedule(
  startDate: Date,
  siteId: string,
  employeesIds: string[],
  visibleDailyTags: DailyTag[],
  displayOptions: DisplayOptions,
  viewFilters: ScheduleViewFilters,
): PrintMonthlyScheduleIn {
  return {
    ...buildCommonParts(employeesIds, visibleDailyTags, displayOptions),
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    date: legacyFormatFrenchDate(startDate),
    idsSites: [siteId],
    mode: "recapparsite",
    tempsTravail: mapToWorkType(displayOptions.workDurationType),
    condensed: displayOptions.showCondensedView,
    arrangement: mapFromArrangementAndOrder(
      viewFilters.viewArrangement,
      viewFilters.employeesOrder,
    ),
  };
}
